import React from 'react'

const PrivacyPolicy = () => {
    return (
        <>
            <iframe
                title="privacy policy"
                src="/privacy_policy.html"
                style={{
                    width: '100%',
                    height: '100vh',
                    border: 'none'
                }}
            />
        </>
    );
}

export default PrivacyPolicy